import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { MeetingSchedulerStoreService } from '../../../data-providers/meeting-scheduler-store.service';
import { MeetingForAction } from '../../interface';
import { RescheduleMeetingDialogComponent } from '../reschedule-meeting-dialog/reschedule-meeting-dialog.component';
import { RescheduleMeetingRequestInterface } from '@vendasta/meetings';
import { POSTHOG_ACTIONS, POSTHOG_CATEGORIES, POSTHOG_KEYS } from '../../../constants';
import { ProductAnalyticsService } from '@vendasta/product-analytics';

@Component({
  selector: 'meeting-scheduler-reschedule-meeting-button',
  templateUrl: './reschedule-meeting-button.component.html',
  styleUrls: ['./reschedule-meeting-button.component.scss'],
  standalone: false,
})
export class RescheduleMeetingButtonComponent implements OnDestroy {
  @Input() meeting: MeetingForAction;
  @Input() isMatItem: boolean;
  @Output() meetingRescheduled: EventEmitter<{ id: string; newDate: Date }> = new EventEmitter();

  private readonly subscriptions: Subscription[] = [];

  constructor(
    private readonly dialog: MatDialog,
    private readonly meetingSchedulerStoreService: MeetingSchedulerStoreService,
    private readonly alertService: SnackbarService,
    private readonly analyticsService: ProductAnalyticsService,
  ) {}

  async openRescheduleDialog(meeting: MeetingForAction): Promise<void> {
    const dialogRef = this.dialog.open(RescheduleMeetingDialogComponent, {
      width: '600px',
      data: meeting,
    });
    const rescheduledMeeting: RescheduleMeetingRequestInterface = await dialogRef
      .afterClosed()
      .pipe(take(1))
      .toPromise();
    if (!rescheduledMeeting) {
      return;
    }

    try {
      await this.meetingSchedulerStoreService.rescheduleMeeting({
        meetingId: rescheduledMeeting.meetingId,
        start: rescheduledMeeting.start,
        isSessionEventType: meeting.isSessionEventType,
      });
      this.analyticsService.trackEvent(
        POSTHOG_KEYS.MEETING_RESCHEDULED,
        POSTHOG_CATEGORIES.USER,
        POSTHOG_ACTIONS.CLICK,
      );
      this.alertService.openSuccessSnack('MEETING_SCHEDULER.MEETING_ACTIONS.ALERTS.RESCHEDULE_MEETING_SAVED');
      this.meetingRescheduled.emit({ id: rescheduledMeeting.meetingId, newDate: rescheduledMeeting.start });
    } catch (err) {
      this.alertService.openErrorSnack('MEETING_SCHEDULER.MEETING_ACTIONS.ALERTS.RESCHEDULE_MEETING_ERROR');
      console.error(err);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
